import type { StoreActionApi } from 'react-sweet-state';
import { getLastHelpseekerMessage } from '../selectors';
import type { State } from '../types';
import { constructHelpseekerMessage } from './construct-helpseeker-message';
import { sendHelpseekerMessage } from './send-helpseeker-message';

export const retryLastHelpseekerMessage =
    () =>
    ({ getState, dispatch }: StoreActionApi<State>) => {
        const state = getState();
        const lastMessage = getLastHelpseekerMessage(state);
        if (!lastMessage) {
            return null;
        }
        const helpseekerMessage = dispatch(constructHelpseekerMessage(lastMessage.message));
        return dispatch(sendHelpseekerMessage(helpseekerMessage));
    };
